import React from 'react';
import { elementType, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import { square } from '../../../internals/utils/stylesHelpers';
const BaseIcon = _ref => {
  let {
    className,
    element
  } = _ref;
  const StyledElement = styled(element)(_ref2 => {
    let {
      theme: {
        spacing
      }
    } = _ref2;
    return {
      ...square(spacing(2))
    };
  });
  return /*#__PURE__*/React.createElement(StyledElement, {
    className: className
  });
};
BaseIcon.propTypes = {
  className: string,
  element: elementType.isRequired
};
export default BaseIcon;